var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46561 0C3.30591 0 0.761719 2.54419 0.761719 5.70389V25.5342C0.761719 28.6939 3.30591 31.2381 6.46561 31.2381H17.2135V19.026H13.9842V14.6292H17.2135V10.8728C17.2135 7.92161 19.1215 5.21189 23.5167 5.21189C25.2963 5.21189 26.6122 5.38273 26.6122 5.38273L26.5087 9.4886C26.5087 9.4886 25.1667 9.47592 23.7022 9.47592C22.1172 9.47592 21.8631 10.2062 21.8631 11.4186V14.6292H26.6347L26.4267 19.026H21.8631V31.2382H26.2959C29.4556 31.2382 31.9998 28.694 31.9998 25.5343V5.70392C31.9998 2.54422 29.4556 3.12381e-05 26.2959 3.12381e-05H6.46558L6.46561 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo-facebook.96bc562beb582a50ca3f836704120e71.svg";
export { ForwardRef as ReactComponent };